import { BodyTypeValue } from 'lib/bodyType';

export const BODY_STYLES = [
  {
    displayName: 'Convertibles',
    searchParams: { body_type: BodyTypeValue.Convertible },
    iconClass: 'convertible',
    queryArray: ['convertible'],
  },
  {
    displayName: 'Coupes',
    searchParams: { body_type: BodyTypeValue.Coupe },
    iconClass: 'coupe',
    queryArray: ['coupe'],
  },
  {
    displayName: 'Crossovers',
    searchParams: { body_type: BodyTypeValue.Crossover },
    iconClass: 'crossover',
    queryArray: ['crossover'],
  },
  {
    displayName: 'Hatchbacks',
    searchParams: { body_type: BodyTypeValue.Hatchback },
    iconClass: 'hatchback',
    queryArray: ['hatchback'],
  },
  {
    displayName: 'Minivans',
    searchParams: { body_type: BodyTypeValue.Minivan },
    iconClass: 'minivan',
    queryArray: ['minivan'],
  },
  {
    displayName: 'Sedans',
    searchParams: { body_type: BodyTypeValue.Sedan },
    iconClass: 'sedan',
    queryArray: ['sedan'],
  },
  {
    displayName: 'SUVs',
    searchParams: { body_type: BodyTypeValue.SUV },
    iconClass: 'suv',
    queryArray: ['suv'],
  },
  {
    displayName: 'Trucks',
    searchParams: { body_type: BodyTypeValue.Truck },
    iconClass: 'truck',
    queryArray: ['truck'],
  },
  {
    displayName: 'Wagons',
    searchParams: { body_type: BodyTypeValue.Wagon },
    iconClass: 'wagon',
    queryArray: ['wagon'],
  },
];

export const FEATURED_TRIMS = [
  {
    displayName: 'BMW 128i',
    make: 'BMW',
    model: '1 Series',
    trim: '128i',
    searchParams: { make: 'BMW', model: '1 Series', 'trim[]': '128i' },
    iconClass: 'BMW',
    queryArray: ['BMW 1 Series', '1 Series', 'BMW 128i', '128i'],
  },
  {
    displayName: 'BMW 135i',
    make: 'BMW',
    model: '1 Series',
    trim: '135i',
    searchParams: { make: 'BMW', model: '1 Series', 'trim[]': '135i' },
    iconClass: 'BMW',
    queryArray: ['BMW 1 Series', '1 Series', 'BMW 135i', '135i'],
  },
  {
    displayName: 'BMW 328i',
    make: 'BMW',
    model: '3 Series',
    trim: '328i',
    searchParams: { make: 'BMW', model: '3 Series', 'trim[]': '328i' },
    iconClass: 'BMW',
    queryArray: ['BMW 3 Series', '3 Series', 'BMW 328i', '328i'],
  },
  {
    displayName: 'BMW 330i',
    make: 'BMW',
    model: '3 Series',
    trim: '330i',
    searchParams: { make: 'BMW', model: '3 Series', 'trim[]': '330i' },
    iconClass: 'BMW',
    queryArray: ['BMW 3 Series', '3 Series', 'BMW 330i', '330i'],
  },
  {
    displayName: 'BMW 335i',
    make: 'BMW',
    model: '3 Series',
    trim: '335i',
    searchParams: { make: 'BMW', model: '3 Series', 'trim[]': '335i' },
    iconClass: 'BMW',
    queryArray: ['BMW 3 Series', '3 Series', 'BMW 335i', '335i'],
  },
];
